import { render, staticRenderFns } from "./NewActivity.vue?vue&type=template&id=4a8bae94&scoped=true"
import script from "./NewActivity.vue?vue&type=script&lang=js"
export * from "./NewActivity.vue?vue&type=script&lang=js"
import style0 from "./NewActivity.vue?vue&type=style&index=0&id=4a8bae94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8bae94",
  null
  
)

export default component.exports